import React from "react";
import "./PageWrapper.css";

export default function PageWrapper({
  children,
  size = "lg",
  as: Component = "main",
  className = "",
  ...props
}) {
  return (
    <Component
      className={["page-wrapper", `page-wrapper--${size}`, className]
        .filter(Boolean)
        .join(" ")}
      {...props}
    >
      {children}
    </Component>
  );
}
